// Text that holds references, drawn as it is written (markdown as plain text,
// line breaks kept) with each `[[kind:id|name]]` drawn as a chip.
//
// Promise: references are found with the one rule every part uses
// (`parseRefs` of `@trameria/core/refs-shared`), so code spans stay text and a
// title link (`[[name]]`) stays as written.
import { parseRefs } from "@trameria/core/refs-shared";
import { useMemo } from "react";
import { RefChip } from "./ref-chip";

type Piece =
  | { type: "text"; at: number; text: string }
  | { type: "ref"; at: number; kind: string; id: string; label: string };

export function splitRefs(markdown: string): Piece[] {
  const out: Piece[] = [];
  let from = 0;
  for (const t of parseRefs(markdown)) {
    if (t.kind === null || t.id === null) continue;
    if (t.at > from)
      out.push({ type: "text", at: from, text: markdown.slice(from, t.at) });
    out.push({ type: "ref", at: t.at, kind: t.kind, id: t.id, label: t.label });
    from = t.at + t.raw.length;
  }
  if (from < markdown.length)
    out.push({ type: "text", at: from, text: markdown.slice(from) });
  return out;
}

export function RefText({
  markdown,
  className = "",
}: {
  markdown: string;
  className?: string;
}) {
  const pieces = useMemo(() => splitRefs(markdown), [markdown]);
  return (
    <div className={`whitespace-pre-wrap break-words ${className}`}>
      {pieces.map((p) =>
        p.type === "text" ? (
          <span key={p.at}>{p.text}</span>
        ) : (
          <RefChip key={p.at} kind={p.kind} id={p.id} label={p.label} />
        ),
      )}
    </div>
  );
}
